/*=========================================================================================
  File Name: moduleNaturalEntityMutations.js
  Description: Auth Module Mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuesax Admin - VueJS Dashboard Admin Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

export default {
  UPDATE_NATURAL_ENTITY(state: any, naturalEntity: Object) {
    state.naturalEntity = naturalEntity
  }
}
